export const DOMAIN_QUESTIONS_ASSIGNMENT = "DOMAIN_QUESTIONS_ASSIGNMENT";
